"use strict";
//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineCommentMark = void 0;
exports.InlineCommentPasteFixPlugin = InlineCommentPasteFixPlugin;
const core_1 = require("@tiptap/core");
const model_1 = require("@tiptap/pm/model");
const state_1 = require("@tiptap/pm/state");
exports.InlineCommentMark = core_1.Mark.create({
    name: 'inline-comment',
    excludes: '',
    inclusive: false,
    parseHTML() {
        return [
            {
                tag: 'span.proseInlineComment[data-inline-comment-thread]'
            }
        ];
    },
    renderHTML({ HTMLAttributes, mark }) {
        return ['span', { ...HTMLAttributes, class: 'proseInlineComment' }, 0];
    },
    addAttributes() {
        const name = 'data-inline-comment-thread-id';
        return {
            thread: {
                default: undefined,
                parseHTML: (element) => {
                    return element.getAttribute(name);
                },
                renderHTML: (attributes) => {
                    return { [name]: attributes.thread };
                }
            }
        };
    },
    addProseMirrorPlugins() {
        return [...(this.parent?.() ?? []), InlineCommentPasteFixPlugin()];
    }
});
function removeMarkFromNode(node, name) {
    if (node.isText) {
        return node.mark(node.marks.filter((mark) => mark.type.name !== name));
    }
    if (node.content.size > 0) {
        const nodes = [];
        node.content.forEach((child) => {
            nodes.push(removeMarkFromNode(child, name));
        });
        return node.copy(model_1.Fragment.fromArray(nodes));
    }
    return node;
}
function InlineCommentPasteFixPlugin() {
    return new state_1.Plugin({
        key: new state_1.PluginKey('inline-comment-paste-fix-plugin'),
        props: {
            transformPasted: (slice) => {
                const nodes = [];
                slice.content.forEach((node) => {
                    nodes.push(removeMarkFromNode(node, 'inline-comment'));
                });
                return new model_1.Slice(model_1.Fragment.fromArray(nodes), slice.openStart, slice.openEnd);
            }
        }
    });
}
//# sourceMappingURL=inlineComment.js.map